import JsEncrypt from 'jsencrypt'
import { serverRSAPrivateKey } from './settings'
import NP from 'number-precision'

/**
 * 当字符数量不及时，给字符前面补0
 * @param value 字符串
 * @param count 期望有多少个字符
 */
export const patchZeroFront = (value, count) => {
  const strValue = value + ''
  const lessCount = count - strValue.length
  if (lessCount <= 0) {
    return value
  }

  let patchValue = strValue
  for (let i = 0; i < lessCount; i++) {
    patchValue = ('0' + patchValue)
  }
  return patchValue
}

/**
 * 定义一个空的function
 * @returns {Function}
 */
export const emptyFn = () => {
  return () => {}
}

/***
 * 刷新缓存时间间隔
 * @returns {number}
 */
export const randomTimerUpdateCache = () => {
  // return 3000
  return Math.round(Math.random() * 15 + 15) * 1000
}
/**
 * 查看是否为空对象
 * {  }
 */
export function isEmptyObject (obj) {
  return !Object.getOwnPropertyNames(obj).length && !Object.getOwnPropertySymbols(obj).length
}

/**
 * 判断是否是数值
 * @param value 数值
 * @returns {boolean}
 */
export const isNumber = (value) => {
  return !isNaN(value)
}

/**
 * 将数值格式化成最大不超过多少位小数的数值，非四舍五入，而是用substring来做的
 * 如setMaxScale(1.289, 2)结果是1.28，而不是1.29
 * @param value 要转换的数值
 * @param maxScale 最大保留几位小数
 * @param isAutoComplete 是否自动补齐2, 2 -> 2.00
 * @returns {*}
 */
export const setMaxScale = (value, maxScale, isAutoComplete = false) => {
  if (!maxScale) {
    maxScale = 4
  }
  let valStr = value.toString()
  if (value === 0) {
    if (isAutoComplete) {
      let scaleCount = maxScale
      valStr += '.'
      while (scaleCount--) {
        valStr += '0'
      }
      return valStr
    }
    return 0
  }
  const nums = valStr.split('.')
  if (nums.length === 1) {
    if (isAutoComplete) {
      let scaleCount = maxScale
      valStr += '.'
      while (scaleCount--) {
        valStr += '0'
      }
      return valStr
    }
    return value
  }
  if (nums.length > 1) {
    if (nums[1].length > maxScale) {
      const end = nums[0].length + 1 + maxScale
      return isAutoComplete ? valStr.substring(0, end) : parseFloat(valStr.substring(0, end))
    }
    if (isAutoComplete) {
      let scaleCount = maxScale - nums[1].length
      while (scaleCount--) {
        valStr += '0'
      }
      return valStr
    }
    return value
  }
  return isAutoComplete ? valStr : value
}

/***
 * 取对象中数值最大的value值
 * @param obj
 * @returns {number|*}
 */
export function getMaxNumberInObj (obj) {
  if (!obj) return 0
  if (typeof obj !== 'object') return obj
  return Math.max(...Object.keys(obj).map(objKey => obj[objKey]))
}

/***
 * 复制参数对象并返回一个新的对象
 * @param source
 * @returns {*[]}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/***
 * 判定是否为字符串
 * @param value
 * @returns {boolean}
 */
export const isString = (value) => {
  return typeof value === 'string'
}

/**
 * forEach for object
 */
export const forEachValue = (obj, fn) => {
  Object.keys(obj).forEach(key => fn(key, obj[key]))
}

/***
 * 格式化模板字符
 * @param template
 * @param argArr
 * @returns {*}
 */
export const formatPlaceholderByNoName = function (template, ...argArr) {
  if (!argArr) {
    return template
  }
  let argIndex = 0
  return template.replace(/\{\}/g, (temp, tempIndex) => {
    if (argArr[argIndex]) {
      return argArr[argIndex++]
    }
    argIndex++
    return ''
  })
}

/**
 * 解密服务器传过来的RSA公钥加密的数据
 * @param str
 * @return {PromiseLike<ArrayBuffer>}
 */
export const rsaPrivateDecryptApiData = (str) => {
  const jse = new JsEncrypt()
  jse.setPrivateKey(serverRSAPrivateKey)
  return jse.decrypt(str)
}

/***
 * 将小数转换成带百分比模式
 * @param number
 */
export function formatNumberToPercent (number) {
  if (!number || !+number) return ''
  return `${NP.times(number, 100)}%`
}

/** *
 * 保存图片(Base64)到本地
 */
export function saveImage (base64Img) {
  let image = new Image()
  // 解决跨域 canvas污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    let canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    let context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    let url = canvas.toDataURL('image/png') // 图片转为base64格式
    let a = document.createElement('a')
    let e = new MouseEvent('click')
    a.download = 'download-image'
    a.href = url
    a.dispatchEvent(e)
  }
  // imgUrl即为要下载图片的路径
  image.src = base64Img
}

/***
 * 同步执行队列事件
 * @param actions
 * @returns {Promise<unknown>}
 */
export function runPromiseActions (actions) {
  return new Promise((resolve, reject) => {
    if (actions.length) {
      const sliceActions = actions.slice()
      sliceActions.shift()().then(() => {
        return runPromiseActions(sliceActions).then(resolve).catch(reject)
      }).catch(() => {
        return new Promise(() => {})
      })
    } else {
      resolve()
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/utils.js